import { Container } from "@mui/material";
import "./Consumptions.scss";
import { useContext, useEffect, useRef, useState } from "react";
import ConsumptionsHeader from "./ConsumptionsHeader/ConsumptionsHeader";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import ConsumptionsPeriod from "./ConsumptionsPeriod/ConsumptionsPeriod";
import ConsumptionsDonwload from "./ConsumptionsDownload/ConsumptionsDownload";
import {
  ConsumptionFormatted,
  ConsumptionsPeriodInformation,
  FormattedComparativeConsumptions,
  SelectedDataComparativeConsumptions,
  SelectedDataPeriodConsumptions,
  SelectedDownloadData,
  SelectedTabConsumptions,
} from "../../core/models/consumptions/consumptions.model";
import { SearchParams } from "../../core/models/consumptionsBillsSearchBar/consumptionsBillsSearchBar.model";
import { initialOwnerDataCup } from "../../utils/ownerData/ownerData.util";
import ConsumptionsComparative from "./ConsumptionsComparative/ConsumptionsComparative";
import { OwnerDataCups } from "../../core/models/ownerData/ownerData.model";
import { ManagementUpdateCup } from "../../core/models/cupsCifSelector/cupsCifSelector.model";
import { initialSelectedDowloadData } from "../../utils/components/consumptions/consumptions.util";

export const Consumptions = () => {
  const { ownerData, userData } = useContext(TotalEnergiesContext);
  const [consumptionsListPeriod, setConsumptionsListPeriod] = useState<
    ConsumptionFormatted[]
  >([]);
  const [scrollPosition, setScrollPosition] = useState<number | null>(null);
  const tableElementRef = useRef<HTMLDivElement>(null);
  const [consumptionsListComparative, setConsumptionsListComparative] =
    useState<FormattedComparativeConsumptions[]>([]);
  const [consumptionsPeriodInformation, setConsumptionsPeriodInformation] =
    useState<ConsumptionsPeriodInformation>({
      dateFrom: "",
      dateTo: "",
      totalActiveEnergy: "",
      totalConsumedEnergy: "",
    });
  const [searchPeriodParams, setSearchPeriodParams] = useState<SearchParams>({
    dateFrom: null,
    dateTo: null,
    ownerDataCup: initialOwnerDataCup,
  });
  const [selectedDataPeriodPeriod, setSelectedDataPeriodPeriod] =
    useState<SelectedDataPeriodConsumptions>({
      consumption: null,
      positionX: null,
      elements: [],
    });
  const [selectedDataPeriodComparative, setSelectedDataPeriodComparative] =
    useState<SelectedDataComparativeConsumptions>({
      consumptions: [],
      positionX: null,
      elements: [],
    });
  const [selectedTab, setSelectedTab] =
    useState<SelectedTabConsumptions>("periodConsumption");
  const [
    ownerDataCupsSelectedComparative,
    setOwnerDataCupsSelectedComparative,
  ] = useState<OwnerDataCups>(initialOwnerDataCup);
  const [selectedDownloadCups, setSelectedDownloadCups] = useState<
    ManagementUpdateCup[]
  >([]);
  const [selectedDownloadData, setSelectedDownloadData] =
    useState<SelectedDownloadData>(initialSelectedDowloadData);

  useEffect(() => {
    if (selectedTab === "download" && scrollPosition) {
      (tableElementRef.current as HTMLDivElement).scrollTop = scrollPosition;
    }
  }, [scrollPosition, selectedTab]);

  return (
    <>
      <ConsumptionsHeader
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
      />
      <Container component="article">
        {selectedTab === "periodConsumption" && (
          <ConsumptionsPeriod
            ownerDataCups={ownerData?.cups || []}
            userData={userData}
            consumptionsList={consumptionsListPeriod}
            setConsumptionsList={setConsumptionsListPeriod}
            consumptionsPeriodInformation={consumptionsPeriodInformation}
            setConsumptionsPeriodInformation={setConsumptionsPeriodInformation}
            searchParams={searchPeriodParams}
            setSearchParams={setSearchPeriodParams}
            selectedDataPeriod={selectedDataPeriodPeriod}
            setSelectedDataPeriod={setSelectedDataPeriodPeriod}
          />
        )}
        {selectedTab === "download" && (
          <ConsumptionsDonwload
            selectedDownloadCups={selectedDownloadCups}
            setSelectedDownloadCups={setSelectedDownloadCups}
            setScrollPosition={setScrollPosition}
            selectedDownloadData={selectedDownloadData}
            setSelectedDownloadData={setSelectedDownloadData}
            tableElementRef={tableElementRef}
          />
        )}
        {selectedTab === "comparativeConsumption" && (
          <ConsumptionsComparative
            ownerDataCups={ownerData?.cups || []}
            userData={userData}
            ownerDataCupSelected={ownerDataCupsSelectedComparative}
            setOwnerDataCupSelected={setOwnerDataCupsSelectedComparative}
            consumptionsList={consumptionsListComparative}
            setConsumptionsList={setConsumptionsListComparative}
            selectedDataPeriod={selectedDataPeriodComparative}
            setSelectedDataPeriod={setSelectedDataPeriodComparative}
          />
        )}
      </Container>
    </>
  );
};

export default Consumptions;
